<script lang="ts" setup>
import NavigationLinks from './NavigationLinks.vue';
</script>

<template>
   <div :class="'mobile-navigation'">
      <NxtHorizontalNavbar>
         <template #links>
            <NavigationLinks :view="'horizontal'" />
         </template>
      </NxtHorizontalNavbar>
   </div>
</template>

<style lang="scss" scoped>
.mobile-navigation :deep(.nxt-horizontal-navbar__more) {
   z-index: 1;
}

.mobile-navigation :deep(.nxt-horizontal-navbar__links) {
   display: grid;
   grid-template-columns: repeat(4, minmax(0, 1fr));
}
</style>
